<template>
  <aside class="aside-container">
    <router-link 
      to="/"
      class="text-xs mx-2 rounded text-blue-10 font-semibold pl-4 py-1 capitalize flex items-center hover:bg-opacity-50 hover:bg-blue-300 transition duration-300 ease-in-out"
    ><i class="ri-home-2-line icon"></i> Início</router-link>
    <div v-for="(item, index) in menu" :key="index">
      <section
        class="bg-blue-900 text-white capitalize flex justify-center mx-2 my-1 rounded"
      >
        <span class="">{{ item.title }}</span>
        <div class="flex items-center ml-2">
          <span v-if="item.title === 'institucional'" class="text-xs capitalize text-yellow-500">(Em breve!)</span>
        </div>
      </section>
      <section class="leading-tight" v-if="item.submenu">
        <ul v-for="(subitem, index) in item.submenu" :key="subitem+index">
          <li class="flex pl-4 py-1 hover:bg-opacity-50 hover:bg-blue-300 rounded mx-2 transition duration-300 ease-in-out">
            <router-link
              v-if="subitem.path"
              :to="subitem.path"
              class="text-xs capitalize flex items-center w-full"
            >
            <i :class="subitem.icon" class="icon"></i>
            <span class="ml-1 text-blue-10 font-semibold">{{ subitem.title }}</span>
            <span v-if="subitem.new" class="ml-1 font-semibold text-orange-500">(NOVO)</span>
            </router-link>
            <a
              v-else
              :href="subitem.url"
              target="_blank"
              class="cursor-pointer text-xs capitalize flex items-center"
              :class="subitem.dropdown ? 'w-4/5' : 'w-full'"
              @click="updateDropdown(subitem)"
            >
              <i :class="subitem.icon" class="icon"></i>
              <span class="ml-1 text-blue-10 font-semibold">{{ subitem.title }}</span>
            </a>
            <i
              v-if="subitem.dropdown"
              @click="subitem.dropdown.status=!subitem.dropdown.status"
              :class="subitem.dropdown.status ? 'ri-arrow-up-s-line w-1/5':'ri-arrow-down-s-line w-1/5'"
              class="cursor-pointer text-blue-20 flex justify-center"
            ></i>
          </li>
          <transition mode="out-in" appear>
            <div v-if="subitem.dropdown?.status" class="mt-1">
              <ul class="mx-2 flex flex-col items-center text-xs border border-blue-200 rounded">
                <li v-for="({ title, url, path }) in subitem.dropdown.content" class="rounded text-blue-10 font-semibold w-full grid grid-cols-4 items-center py-2 hover:bg-opacity-50 hover:bg-blue-200 transition duration-300 ease-in-out">
                  <i class="ri-arrow-right-s-line icon ml-3 bg-blue-200"></i>
                  <a v-if="url" :href="url" target="_blank">{{ title }}</a>
                  <router-link
                    v-if="path"
                    :to="path"
                    class="text-xs capitalize flex items-center w-full"
                  >
                  <span class="ml-1 text-blue-10 font-semibold">{{ title }}</span>
                  </router-link>
                </li>
              </ul>
            </div>
          </transition>
        </ul>
      </section>
    </div>
  </aside>
</template>

<script>
import { reactive } from 'vue';
export default {
  name: 'Sidebar',
  data() {
    return {
      nConstaToggle: false
    }
  },
  setup() {
    const menu = reactive([
      {
        title: 'serviços',
        submenu: [
          {
            title: 'Certidão Negativa',
            icon: 'ri-file-search-line',
            dropdown: {
              status: false,
              content: [
                {
                  title: 'Emitir',
                  url: 'https://sgc.dcc.pm.df.gov.br/nadaconsta/emitirCertidao.faces',
                },
                {
                  title: 'Pesquisar/Validar',
                  url: 'https://sgc.dcc.pm.df.gov.br/nadaconsta/validarCertidao.faces',
                }
              ]
            }
          },
          {
            title: 'SGC',
            icon: 'ri-scales-3-line',
            dropdown: {
              status: false,
              content: [
                {
                  title: 'Acessar',
                  url: 'https://sgc.dcc.pm.df.gov.br/',
                },
                {
                  title: 'Recuperar Senha',
                  path: 'email',
                }
              ]
            }
          },
          // {
          //   title: 'termo de compromisso',
          //   path: 'termo',
          //   icon: 'ri-draft-line',
          // },
          {
            title: 'suporte técnico - SGC',
            url: 'https://suporte.dcc.pm.df.gov.br/',
            icon: 'ri-customer-service-2-line',
          }
        ],
      },
      // {
      //   title: 'institucional',
      // },
      {
        title: 'links',
        submenu: [
          {
            title: 'SEI',
            url: 'https://sip.df.gov.br/sip/login.php?sigla_orgao_sistema=GDF&sigla_sistema=SEI',
            icon: 'ri-folder-4-line',
          },
          {
            title: 'PMDF',
            url: 'https://portal.pm.df.gov.br/',
            icon: 'ri-shield-line',
          },
          {
            title: 'Intranet',
            icon: 'ri-lock-password-line text-green-600 hover:-translate-y-2',
            dropdown: {
              status: false,
              content: [
                {
                  title: 'Acessar',
                  url: 'https://intranet.pm.df.gov.br/',
                },
                {
                  title: 'Recuperar Senha',
                  url: 'https://id.pm.df.gov.br/forgot-password',
                }
              ]
            }
          },
          {
            title: 'SIPOM',
            url: 'https://www.sipom.pm.df.gov.br',
            icon: 'ri-spy-line text-green-600 hover:-translate-y-2'
          },
          {
            title: 'SGPol',
            url: 'https://sgpol.pm.df.gov.br/login',
            icon: 'ri-team-line',
          },
          {
            title: 'gênesis',
            url: 'https://genesis.pm.df.gov.br',
            icon: 'ri-global-line',
          },
          {
            title: 'marcação de consulta',
            url: 'http://marcacao.saude.pm.df.gov.br/marcacaoweb',
            icon: 'ri-stethoscope-line',
          },
          {
            title: 'SVG',
            url: 'http://svg.pm.df.gov.br/SVG/',
            icon: 'ri-user-follow-line',
          },
          {
            title: 'EAD DEC',
            url: 'https://virtual.iscp.edu.br/login/index.php',
            icon: 'ri-book-mark-line',
          }
        ],
      }
    ]);
    
    function updateDropdown(item) {
      menu.forEach(i => {
        if (i.submenu) {
          i.submenu.forEach(sub => {
            if (sub.dropdown && sub.title === item.title) {
              sub.dropdown.status = !sub.dropdown.status;
            }
          });
        }
      });
      
      this.nConstaToggle =! this.nConstaToggle
    }

    return {
      menu,
      updateDropdown
    };
  },
};
</script>

<style scoped>
  .v-enter-active,
  .v-leave-active {
    transition: all 300ms ease;
  }
  .v-enter-from,
  .v-leave-to {
    transform: translate3d(0,-10px,0);
    opacity: 0;
  }
  .aside-container {
    @apply bg-white shadow-md rounded text-blue-20 py-2;
  }
  .icon {
    @apply text-blue-20 text-sm flex justify-center items-center p-1 w-6 h-6 rounded-full;
  }
</style>